import httpInstance from '../httpInstance';

const getDevicesService = async () => {
  let res;
  const endpoint = '/card-acceptance/v1/devices/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getDevicesService;
